const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

function initaddProductToCart(){
  const addToCart = document.querySelectorAll(defaults.addToCart);
  for (let i = 0; i < addToCart.length; i++) {
    addToCart[i].addEventListener('click', function(event) {
      event.preventDefault();
      const formID = this.parentNode.parentNode.getAttribute('id');

      addProductToCart(formID);
    });
  }
}

initaddProductToCart()
function addProductToCart(formID) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + formID)
    .serialize(),
    success: addToCartOk,
    error: addToCartFail,
  });
}

function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      onCartUpdate(cart);

      if (cart.item_count === 0) {
        cartDrawerContent.innerHTML = 'Cart is empty';
        checkoutButton.classList.add('is-hidden');
      } else {
        renderCart(cart);

        var hc_count = 0;
var hc_handle = $('#gift-message').attr('data-product');
        
        checkoutButton.classList.remove('is-hidden');
      }

    },
  });
}

function changeItem(line, callback) {
  const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart();
      }
    },
  });
}

function onCartUpdate(cart) {
  cartCounter && (cartCounter.innerHTML = cart.item_count);
  
  const subtotal = document.querySelector('.sub__total_price')
  subtotal && (subtotal.innerHTML = "$"+(cart.items_subtotal_price/100).toFixed(2))
  
  const cartBag = document.querySelector('.drawer__cart-count')
  
  cartBag && (cartBag.innerHTML =  cart.item_count)
}

function addToCartOk(product) {
  cartModalContent.innerHTML = product.title + ' was added to the cart!';
  //     cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
  //     openAddModal();
  openCartDrawer();
  openCartOverlay();
  fetchCart();
}

function removeProductFromCart() {
  cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
  cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
  openAddModal();
  openCartOverlay();
}
const qtyUpdate = () =>{
  const qtyButton = document.querySelectorAll('.ajax-cart-item__quantity .quantity__button')

  qtyButton.forEach(button =>{
    button.addEventListener('click', (event)=>{
      event.preventDefault();
      const { itemId, itemQuantity } = event.target.dataset;
      let newqty=parseInt(itemQuantity);

      event.target.name === 'plus' ? newqty++ : newqty--;
      data ={
        "quantity": 1,
        "id":itemId
      }

      items = {
        updates: {}
      }

      items.updates[`${itemId}`] = newqty
      
      fetch('/cart/update.js',{
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type':"application/json"
        },
        body:JSON.stringify(items),
      })
      .then(res => res.json())
      .then(res=>{
            onCartUpdate(res);
      fetchCart();
      removeProductFromCart();
    })
//       $.ajax({
//         type: 'POST',
//         url: '/cart/update.js',
//         data: JSON.stringify(items),
//         dataType: 'json',
//         success: function(cart) {
//           console.log(cart)
//           if ((typeof callback) === 'function') {
//             callback(cart);
//           } else {
//             onCartUpdate(cart);
//             fetchCart();
// //             removeProductFromCart();
//           }
//         },
//       });
    })
  })
}
function renderCart(cart) {

  var hc_count = 0;
  var hc_handle = $('#gift-message').attr('data-product');

  var hc_excluded_counter = 0;
  var hc_items;
  var hc_gift = 0;
  var hc_index;

  clearCartDrawer();

  hc_items = cart.item_count;
  
  cart.items.forEach(function(item, index) {

    /* HC - Exclude gift messaging - 01 Aug '22 */
      $.ajax({
    type: "GET",
    url: '/products/' + item.handle + '.js',
    dataType: "json",
    async: false
  }).done(function(product, textStatus, jqXHR) {

    $.each(product.tags, function(index, t) {
      if(t == 'EXCLUDED FROM GIFT NOTE'){
        hc_excluded_counter += item.quantity;
        return false;
      }
    });
  });
    
    const productImage = '<div class="ajax-cart-item__image"><img src="' + item.image + '" ></div>';
    const productVariant='';
    let options='';
    item.options_with_values.map(option => {
      if(option.value !== "Default Title"){
      options = `${options}<span>${option.name} : ${option.value}</span>`;
      }
    })
    /* Start :: Display Color Swatch in Drawer */
    let prop = '';
    const properties = item.properties;
    for (var property in properties) {
      if(properties[property] !== '' && property === 'Color' || properties[property] !== '' && property === 'Gift Note' || properties[property] === 'Final Sale'){
        prop = '<span>'+ property +' : ' +properties[property]+ '</span>';
      }
    }
    /* End */
    const productTitle = '<div class="ajax-cart-item__title">' + item.product_title + prop + options + '</div>';
    
    const productPrice = '<div class="ajax-cart-item__price"><span>$' + (item.line_price/100).toFixed(2) + '</span></div>';
    const qty = `<input class="quantity__input"
                    type="number"
                    name="updates[]"
                    value="${item.quantity}"
                    min="0"
                    >`
    
    const productQuantity = `<div class="ajax-cart-item__quantity"><div class="quantity__wrap hc-${item.handle}">
            <button class="quantity__button no-js-hidden" name="minus" type="button" data-item-id="${item.variant_id}" data-item-quantity="${item.quantity}"><svg width="20" height="1.2" viewBox="0 0 20 1.2"><g transform="translate(0 -9.4)"><path d="M20,.6H0V-.6H20Z" transform="translate(0 10)" fill="#0b3554"/></g></svg></button>
                        ${qty}
                        <button class="quantity__button no-js-hidden" name="plus" type="button" data-item-id="${item.variant_id}" data-item-quantity="${item.quantity}"><svg width="20" height="20" viewBox="0 0 20 20"><path d="M20,.6H0V-.6H20Z" transform="translate(0 10)" fill="#0b3554"/><path d="M20,.6H0V-.6H20Z" transform="translate(10) rotate(90)" fill="#0b3554"/></svg></button>
          </div></div>`;

    const productRemove = '<div class="ajax-cart-item__remove hc-' + item.handle + ' ' + defaults.removeFromCartNoDot + '"><span></span></div>';

    const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + productImage + productTitle + productPrice + productQuantity + productRemove + '</div>';

    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

    /* HC - Exclude gift messaging - 01 Aug '22 */    
    if(hc_excluded_counter == cart.items.length){
      $('[data-gift-note-html]').addClass('hc-hidden');
    }else{
      $('[data-gift-note-html]').removeClass('hc-hidden');
    }

    if (item.handle == 'gift-note') {
      hc_index = index;
          hc_items -= item.quantity;
          hc_gift += item.quantity;
        }
        
  });


  if (hc_items == hc_excluded_counter || cart.item_count == hc_gift) {
          var id = $('#hc-gift-message').attr('data-id');
          var headers = new Headers({
            'Content-Type': 'application/json'
          });

          var request = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
              updates: {
                [id]: 0
              }
            })
          };
          fetch('/cart/update.js', request)
            .then(function(cart) {
              //onCartUpdate(cart);
              fetchCart();
              removeProductFromCart();
              setTimeout(function() {
              $("#hc-gift-message").prop("checked", false);
              $('.og_btn').addClass('hc-drawer-add_msg');
              $('.og_btn').removeClass('hc-drawer-edit');
              $('.og_btn').html('Add Message');
              $('#msg_text textarea').val('');
              $('#msg_text textarea').removeClass('note_saved');
              $('.hc-message').removeClass('hc-shown');
              $('.hc-message').hide();
              $('.hc-characters').text('0');
              }, 150);
            });
        }

  // document.querySelectorAll('.js-ajax-remove-from-cart')
  //     .forEach((element) => {
  //         element.addEventListener('click', function() {
  //             const lineID = this.parentNode.getAttribute('data-line');
  //             console.log('aa');
  //         });
  //     });

  removeFromCart = document.querySelectorAll(defaults.removeFromCart);

  for (let i = 0; i < removeFromCart.length; i++) {
    removeFromCart[i].addEventListener('click', function() {
      const line = this.parentNode.getAttribute('data-line');
      changeItem(line);
    });
  }
  
  qtyUpdate();

}

function openCartDrawer() {
  cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}

function openAddModal() {
  cartModal.classList.add('is-open');
}

function closeAddModal() {
  cartModal.classList.remove('is-open');
}

function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function() {
  closeAddModal();
  closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function() {
  closeCartDrawer();
  closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
  closeAddModal();
  closeCartDrawer();
  closeCartOverlay();
});

cartDrawerTrigger && cartDrawerTrigger.addEventListener('click', function(event) {
  event.preventDefault();
  //fetchCart();
  openCartDrawer();
  openCartOverlay();
});

document.addEventListener('DOMContentLoaded', function() {
  fetchCart();
qtyUpdate()
  
});


 





const showAddressForm = () =>{
  
 const addressForm = document.querySelector('#AddAddress')
 const addressLists =  document.querySelectorAll('.address__list')
 addressLists.forEach(addressList => {
   addressList.style.display = "none"
 })
 if(addressForm){
   addressForm.style.display = "block"
 }
}

const hideAddressForm = () =>{
 const addressForm = document.querySelector('#AddAddress')
 const addressLists =  document.querySelectorAll('.address__list')
 addressLists.forEach(addressList => {
   addressList.style.display = "flex"
 })
 if(addressForm){
   addressForm.style.display = "none"
 }
}

const showEditForm = () =>{
 const addressForm = document.querySelector('#AddAddress')
 
 if(addressForm){
   addressForm.style.display = "none"
 }
}


addressAction = document.querySelector('.add-new-address')
cancelAddAddress = document.querySelector('.cancel-add-address')
editAddresses = document.querySelectorAll('.edit-address')
cancelAddresses = document.querySelectorAll('.cancel-edit-address')


addressAction && addressAction.addEventListener('click',showAddressForm)
cancelAddAddress && cancelAddAddress.addEventListener('click',hideAddressForm) 


editAddresses.forEach(editAddress => {
 
  editAddress && editAddress.addEventListener('click',(e)=>{
    e.preventDefault()
    
    editForms = document.querySelectorAll('.edit__form')
    editForms.forEach(form => {
      form.style.display = "none"
    })
    
    const addressLists =  document.querySelectorAll('.address__list')
    addressLists.forEach(addressList => {
      addressList.style.display = "none"
    })
    
    const { addressId } = e.target.dataset;
    editFormElement = document.querySelector(`#EditAddress_${addressId}`)
    editFormElement && (editFormElement.style.display = "block")
//    todo
  })
})

cancelAddresses && cancelAddresses.forEach(editAddress => {
  
  editAddress && editAddress.addEventListener('click',(e)=>{
    e.preventDefault()
    
    editForms = document.querySelectorAll('.edit__form')
    editForms.forEach(form => {
      form.style.display = "none"
    })
    
    const addressLists =  document.querySelectorAll('.address__list')
    addressLists.forEach(addressList => {
      addressList.style.display = "flex"
    })
  })
})


const thumbnails = document.querySelectorAll('.product-thumbnail li a')
thumbnails.forEach(thumbnail=>{
  thumbnail.addEventListener('click', function(event) {

    event.preventDefault()
    const {thumbnailId} = event.target.dataset;

    const productMasterImages = document.querySelectorAll('.product__media-item.grid__item')
    productMasterImages.forEach(image=>{
      image.classList.remove('active-image')
    })
    
    const productThumbanailImages = document.querySelectorAll('.thumbnail__item')
    productThumbanailImages.forEach(image=>{
      image.classList.remove('active-image')
    })
    $(`.media-thumbnail-id_${thumbnailId}`).addClass('active-image')
    
    $(`.media-id_${thumbnailId}`).addClass('active-image')
    $('html,body').animate({
      scrollTop: ($(`.media-id_${thumbnailId}`).first().offset().top)
    },500);
  })
})


$(document).ready(function () {
  // $(document).on("scroll", onScrollMobileAtc);
  
  if(window.innerWidth < 768) {
    $('.footer-block__heading').on('click', function(event){
         event.preventDefault();
         var accordion = $(this);
        var accordionContent = accordion.next('.mobile-accordion__panel');

      accordion.find('span').toggleClass("expanded")
        // toggle accordion link open class
        // toggle accordion content
        accordionContent.slideToggle(250);
      });
    }else{
      $('.mobile-accordion__panel').css("display","block")
    }

  
   $('input.search__input').on('input',function(e){
     $(this).parents('.search-modal__form').addClass('search__active')
    if($(this).val().length==0){
      $(this).parents('.search-modal__form').removeClass('search__active')
    }
  });
  $('.clear__search').on('click',function(e){
    $('input.search__input').val("")
     $(this).parents('.search-modal__form').removeClass('search__active')
  })
});


$=jQuery;
let triggered = false;

function loadMoreButton(){
  $( ".load_more" ).click(function(e) {
    e.preventDefault()
    ScrollExecute();
  });
}

function ScrollExecute() {
  let moreButon = $('.load_more').last();
  let nextUrl = $(".load_more").attr("href");
  if (triggered == false) {
    triggered = true;
    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function() {
      }
    })
    .done(function(data) {
      $('#product-grid').append($(data).find('#product-grid').html());
      if($(data).find('.load-more__pagination').html()){
      $('.load-more__pagination').html($(data).find('.load-more__pagination').html());
      }else{
        $('.load-more__pagination').css("display","none")
      }
      triggered = false
      
      for (let i = 0; i < addToCart.length; i++) {
        addToCart[i].removeEventListener('click', function(event) {
          event.preventDefault();
          const formID = this.parentNode.parentNode.getAttribute('id');

          addProductToCart(formID);

    });

  }
      
  initaddProductToCart();
      loadMoreButton();
      loadAddtoCartForm();
    });
  }
}

function  loadAddtoCartForm(){
  $.each($('.card-wrapper'),function(){
    const wrapper = $(this);
    let jsonText = '';
    jsonText = $(this).find('[type="application/json"]').text();
    let variantData = '';
    if(jsonText != ''){
      variantData = JSON.parse(jsonText);
    }
    const sizeOptions = wrapper.find(`input[name="Size"]`)
    if(sizeOptions.length>1){
      $.each(variantData,function(index,variant) {
        const {id, options} = variant;
        if(!variant.available){

          sizeOptions && variant.options.map((option, index) => {
            const variantLabel = wrapper.find(`input[name="Size"][value='${option}']`)

            if(variantLabel){
              const label= document.querySelector(`label[for="${variantLabel.attr('id')}"]`)
              label && label.classList.add('sold-out')
            }
          })
        }
      })
    }else{
      $.each(variantData,function(index,variant) {
        const {id, options} = variant;
        const addButton = wrapper.find(`[name="add"]`);
        wrapper.find(`[name="id"]`).value=id
        addButton.removeClass('button--accent-outline')
        const addButtonText = wrapper.find(`[name="add"] > span`);
        wrapper.find('input[type="radio"]').attr("checked","checked")
        if(variant.available){
          addButton.removeAttr('disabled');

          addButtonText.text( window.variantStrings.addToCart + " - $" + (variant.price/100).toFixed(2));
        }else{
          addButton.attr('disabled', 'disabled');
          addButtonText.text("Sold Out");
        }

      })
    }
  })

  $('.card-wrapper input[type="radio"]').on('click change', function(e) {

    const {id, value} = e.target;
    const {productId:pid} = e.target.dataset ;
    const varinatData = JSON.parse(document.querySelector(`#product_form_${pid} [type="application/json"]`).textContent);
    const addButtonText = document.querySelector(`#product_form_${pid} [name="add"] > span`);
    varinatData.forEach(variant => {
      const {id, options} = variant;
      options.forEach(option =>{
        if(option === value) {
          const addButton = document.querySelector(`#product_form_${pid} [name="add"]`);
          $(`#product_form_${pid} [name="id"]`).val(id)
          addButton.classList.remove('button--accent-outline')
          if(variant.available){
            addButton.removeAttribute('disabled');

            addButtonText.textContent = window.variantStrings.addToCart + " - $" + (variant.price/100).toFixed(2);
          }else{
            addButton.setAttribute('disabled', 'disabled');
            addButtonText.textContent = "Sold Out";
          }
        }

      })
    })
  });
}



$(document).ready(function () {
  loadMoreButton();
  loadAddtoCartForm();
});